import React, { useMemo } from 'react';
import cx from 'classnames';
import styles from './Well.module.scss';
import { ChromeIcon, EdgeIcon, AndroidIcon, IosIcon, CheckIcon, DownloadIcon } from './icons';
import iosStore from '../../assets/ios-store.png';
import playStore from '../../assets/play-store.png';
import { useTranslation } from 'react-i18next';

export default function Well(props) {
  const { title, body, icon, btnType = 'download', btnLink, installed, handleNextStep } = props;

  const { t } = useTranslation();

  const iconComponent = useMemo(() => {
    switch (icon) {
      case 'chrome':
        return <ChromeIcon />;
      case 'edge':
        return <EdgeIcon />;
      case 'android':
        return <AndroidIcon />;
      case 'ios':
        return <IosIcon />;
    }
  }, [icon]);

  return (
    <div className={cx(styles.well)}>
      <div className={styles.wellTitle}>
        <h1>{title}</h1>
        {iconComponent}
      </div>

      <p className={cx(styles.wellBody)}>{body}</p>
      {btnType == 'android' || btnType == 'ios' ? (
        <a href={btnLink} className={cx(styles[btnType], styles.btnAppStore)} target="_blank" onClick={handleNextStep} aria-label="Open">
          <img src={btnType == 'android' ? playStore : iosStore} alt={t('dashboard.new_video.install.visit')} />
        </a>
      ) : (
        <a
          href={btnLink}
          className={cx({ [styles.installed]: installed, [styles.download]: !installed }, styles.aButton, 'button')}
          target="_blank"
          onClick={handleNextStep}
        >
          {installed ? <CheckIcon /> : <DownloadIcon />} {btnType}
        </a>
      )}
    </div>
  );
}
